import { fromBase64 } from '@aws-sdk/util-base64'
import styled from '@emotion/styled'
import dayjs from 'dayjs'
import EventEmitter from 'events'
import { motion } from 'framer-motion'
import { encode } from 'js-base64'
import { set, unionBy } from 'lodash-es'
import md5 from 'md5'
import { Status } from 'rc-steps/lib/interface'
import { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import { clearInterval, setInterval } from 'worker-timers'

import { getServerTimes } from '@/api/center'
import {
  buriedPoint,
  fetchCouseLevel3,
  getRoomType,
  getRoomUserInfo,
  getZegoToken,
  leaveRoom,
  roomConfig,
  setresolution,
  startRecord,
  stopRecord,
  uploadTurnverInfo,
  UploadUserInfo,
  uploadUserInfo,
  verityRoomUser
} from '@/api/room'
import GlobalDeviceChange from '@/components/GlobalDeviceChange'
import Modal from '@/components/Modal'
import useGetRecoilState from '@/hooks/useGetRecoilState'
import {
  autoplayState,
  captionsState,
  CoursewareList,
  coursewareListState,
  drawLineDataState,
  lineColorState,
  lineWidthState,
  penStateState,
  picLayoutState,
  VideoCoursewareList,
  videoCoursewareListState,
  viewPicIdState
} from '@/store/courseware'
import {
  audioLiveState,
  basicInfoState,
  bigWinState,
  breadInClassInfoState,
  canChangeRTCLineState,
  correctInfoListState,
  correctionState,
  defaultPos,
  dotFrequencyState,
  drawMethodModalState,
  drawMethodState,
  enterBackgroundControlState,
  isStuOnlineState,
  isTeaOnlineState,
  justUserState,
  LineType,
  paramsState,
  restState,
  roomLineState,
  roomReadyState,
  roomWindowScaleState,
  rtmReadyState,
  rtmUserState,
  screenSharingState,
  syncStateState,
  teacherSmallVideoInfoState,
  teacherVideoInfoState,
  useDeviceState,
  videoLiveStuState,
  videoLiveTeaState
} from '@/store/room'
import { Board, Lines, PageData } from '@/utils/board'
import Rtc from '@/utils/rtc'
import Rtm from '@/utils/rtm'
// import Tim from '@/utils/tim'
import { browserType, checkOS, getBrowser, getMacOsVersion } from '@/utils/tool'

import Courseware, { coursewareBoard } from './components/Courseware'
import Head from './components/Head'
import ReadyEvent from './components/ReadyEvent'
import Rest from './components/Rest'
import Reward from './components/Reward'
import Step from './components/Step'
import Tools from './components/Tools'
import Video from './components/Video'
import { justStudentVideoBoard, mainStudentVideoBoard, viceStudentVideoBoard } from './components/Video/components/Student'
import { viceTeacherVideoBoard } from './components/Video/components/Teacher'
import { justTeacherVideoBoard, mainTeacherVideoBoard, TeacherTemp } from './components/Video/TeacherVideo'
import TeacherVideo from './components/Video/TeacherVideo'
import VideoFrame from './components/VideoFrame'

const boardToPrefix: { [preId: string]: Board } = {
  10: mainTeacherVideoBoard,
  11: viceTeacherVideoBoard,
  12: justTeacherVideoBoard,
  20: mainStudentVideoBoard,
  21: viceStudentVideoBoard,
  22: justStudentVideoBoard
}

/**
 * import { roomEvent, rtcClient, rtmClient } from 'src/pages/room/index.tsx'
 *
 * roomEvent 教室内全局发布订阅对象
 * rtcClient 教室内全局rtc对象
 * rtmClient 教室内全局rtm对象
 *
 * 发布
 * roomEvent.emit('xxx', args) 全局搜索 roomEvent.emit 查看已发布事件
 *
 * 订阅
 * roomEvent.on('xxx', fc) 订阅必须销毁
 */
export const roomEvent = new EventEmitter()
export const rtcClient = new Rtc()
export const rtmClient = new Rtm(import.meta.env.VITE_APP_AGORA_APPID)
// export const rtmClient = new Tim(import.meta.env.VITE_APP_AGORA_APPID)
export const bigWindow = '0.000000,0.000000,640.000000,480.000000'
// 课堂超时时间
const classTimeout = 3 * 60 * 60

export default function Index() {
  const navigate = useNavigate()
  const [step, setStep] = useState(0)
  const [status, setStatus] = useState<Status>('process')
  const [errorTxt, setErrorText] = useState<string>('')
  const [outState, setOutState] = useState<boolean>(false)
  // const [tokens, setTokens] = useState({
  //   rtmToken: '',
  //   rtcToken: '',
  //   smallScreenRtcToken: ''
  // })
  const [useDevice, setUseDevice] = useRecoilState(useDeviceState)
  const correction = useRecoilValue(correctionState)
  const [correctInfoList, setCorrectInfoList] = useRecoilState(correctInfoListState)
  const [justUser, setJustUser, getJustUser] = useGetRecoilState(justUserState)
  const [, setCoursewareList, getCoursewareList] = useGetRecoilState(coursewareListState)
  const [, setVideoCoursewareList, getVideoCoursewareList] = useGetRecoilState(videoCoursewareListState)
  const [drawLineData, setDrawLineData] = useRecoilState(drawLineDataState)
  const [penState, setPenState, getPenState] = useGetRecoilState(penStateState)
  const [, setSyncState, getSyncState] = useGetRecoilState(syncStateState)
  const [, setViewPicId, getViewPicId] = useGetRecoilState(viewPicIdState)
  const [bigWin, setBigWin, getBigWin] = useGetRecoilState(bigWinState)
  const [, , getLineColor] = useGetRecoilState(lineColorState)
  const [, , getLineWidth] = useGetRecoilState(lineWidthState)
  const [picLayout, setPicLayout] = useRecoilState(picLayoutState)
  const [teacherVideoInfo, setTeacherVideoInfo] = useRecoilState(teacherVideoInfoState)
  const [teacherSmallVideoInfo, setTeacherSmallVideoInfo] = useRecoilState(teacherSmallVideoInfoState)
  const firstDot = useRef<boolean>(true) // 第一次打点
  const [dotFrequency, setDotFrequency] = useRecoilState(dotFrequencyState)
  const [params, setParams, getParams] = useGetRecoilState(paramsState)
  const [basicInfo, setBasicInfo] = useRecoilState(basicInfoState)
  const [roomReady, setRoomReady] = useRecoilState(roomReadyState)
  const [breadInClassInfo, setBreadInClassInfo] = useRecoilState(breadInClassInfoState)
  const setEnterBackgroundControl = useSetRecoilState(enterBackgroundControlState)
  const [, setIsStuOnline, getIsStuOnline] = useGetRecoilState(isStuOnlineState)
  const [, setIsTeaOnline, getIsTeaOnline] = useGetRecoilState(isTeaOnlineState)
  const [rtmUser, setRtmUser] = useRecoilState(rtmUserState)
  const [, setRoomLine, getRoomLine] = useGetRecoilState(roomLineState)
  const [, setCanChangeRTCLine] = useRecoilState(canChangeRTCLineState)
  const [, setRtmReady] = useRecoilState(rtmReadyState) // rtm是否准备好
  const [roomWindowScale, setRoomWindowScale] = useRecoilState(roomWindowScaleState)
  const [screenSharing, setScreenSharing] = useRecoilState(screenSharingState)

  const roomTimeRef = useRef<number>(-1)
  const roomDateTimeRef = useRef<number>(0)
  const [searchParams] = useSearchParams()
  const resetCaptions = useResetRecoilState(captionsState)
  const restPenState = useResetRecoilState(penStateState)
  const restSyncState = useResetRecoilState(syncStateState)
  const resetRest = useResetRecoilState(restState)
  const resetViewPicId = useResetRecoilState(viewPicIdState)
  const resetRoomReady = useResetRecoilState(roomReadyState)
  const resetAutoplay = useResetRecoilState(autoplayState)
  const resetUseDevice = useResetRecoilState(useDeviceState)
  const resetParams = useResetRecoilState(paramsState)
  const resetBigWin = useResetRecoilState(bigWinState)
  const resetBasicInfo = useResetRecoilState(basicInfoState)
  const resetCorrectInfoList = useResetRecoilState(correctInfoListState)
  const resetJustUser = useResetRecoilState(justUserState)
  const resetCoursewareList = useResetRecoilState(coursewareListState)
  const resetVideoTeaLive = useResetRecoilState(videoLiveTeaState)
  const resetVideoStuLive = useResetRecoilState(videoLiveStuState)
  const resetAudioLive = useResetRecoilState(audioLiveState)
  const resetEnterBackgroundControl = useResetRecoilState(enterBackgroundControlState)
  const resetIsStuOnline = useResetRecoilState(isStuOnlineState)
  const resetRoomLine = useResetRecoilState(roomLineState)
  const resetCanChangeRTCLine = useResetRecoilState(canChangeRTCLineState)
  const resetRtmUser = useResetRecoilState(rtmUserState)
  const resetDrawMethod = useResetRecoilState(drawMethodState)
  const resetDrawMethodModal = useResetRecoilState(drawMethodModalState)
  const resetRtmReady = useResetRecoilState(rtmReadyState)

  // 启动与销毁
  useEffect(() => {
    setStep(1)
    rtmClient.on('user-kicked', userKicked)
    rtmClient.on('user-add', userAdd)
    rtmClient.on('user-leave', userLeave)
    return () => {
      const { roomId, datetime, lessonType, teacherId, studentId, courseId, lessonTimeId } = getParams()
      // 停止录制
      // stopRecord({ key: roomId }, { channel: roomId }).then((res) => {
      //   console.info('停止录制:', res)
      // })
      // 【灰度课件埋点接口】完课后调用
      // if (courseId && lessonTimeId) {
      //   buriedPoint({
      //     courseId: courseId,
      //     lessonTimeId: lessonTimeId,
      //     roomId: roomId,
      //     userId: studentId
      //   })
      // }
      // 退出教室
      leaveRoom({
        roomid: roomId,
        bundleid: import.meta.env.VITE_APP_TIME,
        user_role: 2, // 用户类型 1 老师 2 学生
        class_time: datetime, // 退出教室需要带开始时间
        lesson_id: sessionStorage.lessonId,
        classroom_line: 'sw', // 线路
        curriculum_type: lessonType,
        userid: studentId
      }).then((res) => {
        console.info('退出教室:', res)
      })
      // 退出上报
      reportInfo('quit')
      rtmClient.removeListener('user-kicked', userKicked)
      rtmClient.removeListener('user-add', userAdd)
      rtmClient.removeListener('user-leave', userLeave)
      rtmClient.leave()
      rtmClient.logout()
      rtcClient.destroy()
      if (roomTimeRef.current >= 0) {
        clearInterval(roomTimeRef.current)
        roomTimeRef.current = -1
      }
      // 重置Recoil状态为默认值,初始化时会赋值的状态一般无需重置
      resetCaptions() // 提词器
      restPenState() // 画笔
      restSyncState() // 模式
      resetRest() // 课间休息
      resetViewPicId() // 默认课件
      resetRoomReady() // 房间准备好
      resetAutoplay() // 播放状态
      resetUseDevice() // 选中的设备
      resetParams() // 入参
      resetBigWin() // 大窗
      resetBasicInfo() // 学员信息
      resetCorrectInfoList() // 矫正信息
      resetJustUser() // just信息
      resetCoursewareList() // 课件
      resetVideoTeaLive() // 老师视频
      resetVideoStuLive() // 学员视频
      resetAudioLive() // 音频状态
      resetEnterBackgroundControl() // 学员切后台
      resetIsStuOnline() // 学员是否在线
      resetRoomLine() // 房间线路
      resetCanChangeRTCLine() // 是否可以切换房间线路
      resetRtmUser() // rtm用户
      resetDrawMethod()
      resetDrawMethodModal()
      resetRtmReady()
      // 清除画板
      mainTeacherVideoBoard.destroy()
      viceTeacherVideoBoard.destroy()
      justTeacherVideoBoard.destroy()
      mainStudentVideoBoard.destroy()
      viceStudentVideoBoard.destroy()
      justStudentVideoBoard.destroy()
      coursewareBoard.destroy()
    }
  }, [])

  // 加载步骤
  useEffect(() => {
    if (step === 1) {
      initParams()
    }
    if (step === 2) {
      getRemoteData()
    }
    if (step === 3) {
      initMedia()
    }
    if (step === 4) {
      setStatus('finish')
      setTimeout(() => {
        setStep(5)
      }, 300)
    }
    if (step === 5) {
      setRoomReady(true)
    }
  }, [step])

  // 临时房间学员未进入时没有学员ID，监听学生ID变化，重置初始just、镜像数据结构
  useUpdateEffect(() => {
    // 初始化just
    let jUser = { [params.mainStudentId]: false }
    if (params.teacherId) {
      jUser[params.mainTeacherId] = false
    }
    jUser = { ...jUser, ...justUser }
    setJustUser(jUser)

    // 初始化镜像
    // let oldCorrectInfoList: { [userId: string]: number } = {}
    // correctInfoList.forEach((v) => {
    //   oldCorrectInfoList[v.userId] = v.status
    // })
    // let correctInfo = {
    //   [params.mainTeacherId]: 0,
    //   [params.viceTeacherId]: 0,
    //   ...oldCorrectInfoList
    // }
    // if (params.studentId) {
    //   correctInfo[params.mainStudentId] = 0
    //   correctInfo[params.viceStudentId] = 0
    // }
    // correctInfo = {
    //   ...correctInfo,
    //   ...oldCorrectInfoList
    // }
    // setCorrectInfoList(Object.keys(correctInfo).map((v) => ({ userId: v, status: correctInfo[v] } as CorrectInfo)))
  }, [params])

  // 打点
  // useEffect(() => {
  //   roomEvent.on('roomTime', dot)
  //   return () => {
  //     roomEvent.removeListener('roomTime', dot)
  //   }
  // }, [dotFrequency, step])

  // 画笔授权，需要收回老师的白板权限（放在这个地方是因为这个文件白板、bigWin、justUser、penState状态都齐全）
  useUpdateEffect(() => {
    if (penState) {
      mainTeacherVideoBoard.setConf({ tool: 0 })
      viceTeacherVideoBoard.setConf({ tool: 0 })
      justTeacherVideoBoard.setConf({ tool: 0 })
      mainStudentVideoBoard.setConf({ tool: 0 })
      viceStudentVideoBoard.setConf({ tool: 0 })
      justStudentVideoBoard.setConf({ tool: 0 })
      coursewareBoard.setConf({ tool: 0 })
    } else {
      switch (bigWin) {
        case 1:
          coursewareBoard.setConf({ tool: 1 })
          break
        case 2:
          if (params.mainTeacherId) {
            justUser[params.mainTeacherId] ? justTeacherVideoBoard.setConf({ tool: 1 }) : mainTeacherVideoBoard.setConf({ tool: 1 })
          }
          break
        case 3:
          viceTeacherVideoBoard.setConf({ tool: 1 })
          break
        case 4:
          justUser[params.mainStudentId] ? justStudentVideoBoard.setConf({ tool: 1 }) : mainStudentVideoBoard.setConf({ tool: 1 })
          break
        case 5:
          viceStudentVideoBoard.setConf({ tool: 1 })
          break
      }
      justUser
    }
  }, [penState])

  // 互踢
  const userKicked = useCallback(() => {
    setOutState(true)
    setTimeout(() => {
      exit()
    }, 2000)
  }, [])

  // 用户加入
  const userAdd = useCallback((userId: string) => {
    console.log('user-add', userId)
    if (userId.slice(0, 2) === '10') {
      // 如果用户先进教室,user-add不会发第二遍,需要收到repHello就认定学员在教室
      setIsTeaOnline(true)
    }
  }, [])
  // 用户离开
  const userLeave = useCallback((userId: string) => {
    console.log('user-leave', userId)
    // 学员离开收回画笔
    if (userId.slice(0, 2) === '10') {
      setPenState(true)
      setIsTeaOnline(false)
    }
  }, [])

  // 上报打点
  // const dot = useCallback(
  //   (second: number) => {
  //     // console.info('打点频率：', dotFrequency, second)
  //     if (dotFrequency && step >= 5) {
  //       const { lessonTimeId, datetime, teacherId, studentId } = getParams()
  //       if ((second % dotFrequency === 0 || firstDot.current) && lessonTimeId && studentId) {
  //         firstDot.current = false
  //         const data: UploadUserInfo[] = [
  //           {
  //             lessonTimeId,
  //             userId: studentId,
  //             userType: 2,
  //             classTime: datetime,
  //             classType: 2,
  //             deviceType: 'PC',
  //             time: datetime + second
  //           }
  //         ]
  //         if (getIsStuOnline()) {
  //           data[0].classType = 1
  //           data.push({
  //             lessonTimeId,
  //             userId: teacherId,
  //             userType: 1,
  //             classTime: datetime,
  //             classType: 1,
  //             deviceType: 'APP',
  //             time: datetime + second
  //           })
  //         }
  //         // 打点上报
  //         uploadUserInfo({
  //           data: JSON.stringify(data)
  //         })
  //       }
  //     }
  //   },
  //   [dotFrequency, step]
  // )

  // 整理入参
  const initParams = async () => {
    try {
      // 打印入参
      const params: { key: string; value: string }[] = []
      searchParams.forEach((value: string, key: string) => {
        params.push({ key, value })
      })
      console.table(params)
      console.info(params)

      // 入参解析
      const roomId = searchParams.get('roomId') || ''
      const isTempClass = roomId.length <= 6
      const datetime = Number(isTempClass ? searchParams.get('classTime') || dayjs().unix() : searchParams.get('datetime'))
      const date = dayjs(datetime * 1000).format('YYYY-MM-DD')
      const teacherId = Number(searchParams.get('teacher')) // TODO: 临时教室没有老师ID
      const timesRange = `${datetime * 1000}-${datetime * 1000 + 3600000}`
      // const datetime: number = parseInt(`${new Date().getTime() / 1000}`) - 1440 // 前1分钟
      // const datetime: number = parseInt(`${new Date().getTime() / 1000}`) - 1560 // 开始后1分钟
      // const datetime: number = parseInt(`${new Date().getTime() / 1000}`) - 1980 // 结束前2分钟
      // const datetime: number = parseInt(`${new Date().getTime() / 1000}`) - 2160 // 结束后1分钟
      // const datetime = Number((Number(timesRange?.split('-')[0]) / 1000).toFixed(0))
      const lessonId = Number(searchParams.get('lessonId')) // TODO: 正式课没有lessonId
      const lessonType = Number(searchParams.get('lessonType')) === 1 ? 2 : 1 // 和老师的传值是反的
      const lessonTimeId = Number(isTempClass ? searchParams.get('lessonTimeId') : searchParams.get('timesId'))
      const heartBeatRate = Number(searchParams.get('heartBeatRate') || '60') // 心跳频率 默认60
      const studentId = Number(searchParams.get('userId'))
      const studentHead = searchParams.get('studentHead') // TODO: 正式课没有
      const courseId = Number(searchParams.get('courseId')) // TODO: 临时课没有
      const studentName = isTempClass ? searchParams.get('studentName') : searchParams.get('userName')
      let mainCamera = searchParams.get('masterCamera') || ''
      let viceCamera = searchParams.get('viceCamera') || ''
      let microphone = ''
      let playback = ''

      if (!(roomId && datetime)) {
        toast.error('参数不全，请退出重试')
        throw '参数不全，请退出重试'
      }

      if (!mainCamera) {
        const cameras = await Rtc.getCameras()
        mainCamera = cameras[0]?.deviceId || ''
        viceCamera = cameras[1]?.deviceId || ''
      }
      if (!microphone) {
        const microphones = await Rtc.getMicrophones()
        microphone = microphones[0]?.deviceId || ''
      }
      if (!playback) {
        const playbacks = await Rtc.getPlaybacks()
        playback = playbacks[0]?.deviceId || ''
      }
      setUseDevice((v) => ({ ...v, mainCamera, viceCamera, microphone, playback }))

      setDotFrequency(heartBeatRate)
      setParams({
        date,
        type: 2,
        teacherId,
        roomId,
        timesRange,
        datetime,
        lessonId,
        lessonType,
        lessonTimeId,
        heartBeatRate,
        studentId,
        studentHead,
        courseId,
        studentName,
        // 是否临时房间
        isTempClass,
        mainTeacherId: `10${teacherId}`,
        viceTeacherId: `11${teacherId}`,
        justTeacherId: `12${teacherId}`,
        mainStudentId: studentId ? `20${studentId}` : '',
        viceStudentId: studentId ? `21${studentId}` : '',
        justStudentId: studentId ? `22${studentId}` : ''
      })

      // 全局上课时间计时器
      const isTimeout = await roomTimeClock(datetime)
      if (isTimeout) {
        toast.error('本节课程已超时')
        throw '本节课程已超时'
      }

      // next - 2
      setStep(2)
    } catch (e) {
      console.info(e)
      setErrorText(JSON.stringify(e))
      setStatus('error')
    }
  }

  // 接口数据
  const getRemoteData = async () => {
    try {
      const { roomId, studentId, lessonTimeId, courseId, isTempClass } = params

      // 获取分辨率 - 启动调用
      // await roomConfig({ configKey: 'webVideoEncoderConfiguration' })
      let newCourseId = 0
      if (studentId) {
        // 获取用户信息 - 用户信息卡片使用
        const roomUserInfo = await getRoomUserInfo({ userId: studentId, lessonTimeId })
        console.log('API getRoomUserInfo', roomUserInfo)
        const { plansInfo, basicInfo, worksInfo } = roomUserInfo.data
        setBasicInfo({ ...basicInfo, plansInfo, worksInfo })
        const { id = 0 } = plansInfo[0] || {}
        newCourseId = id
        // 课中更换课件刷新
        if (newCourseId && newCourseId !== courseId) {
          setParams((v) => ({ ...v, courseId: newCourseId }))
        }
      }
      let line: LineType = 'agora'
      // 线路
      const roomTypeRes = await getRoomType({ cname: roomId, timesId: lessonTimeId })
      if (roomTypeRes.status === 0) {
        if (roomTypeRes.data.roomType === 1) {
          line = 'agora'
        } else if (roomTypeRes.data.roomType === 2) {
          line = 'zego'
        } else {
          line = 'trtc'
        }
        setCanChangeRTCLine(roomTypeRes.data.canChangeRTCLine)
      } else {
        if (!isTempClass) {
          throw roomTypeRes.msg
        }
      }
      console.info(`%c 线路 %c ${line} `, 'color: #fff; background: #5f5f5f', 'color: #fff; background: #F44336')

      setRoomLine(line)
      // Rtc ready
      rtcClient.ready(line)

      // 用户在房间信息、课件休息信息
      // const roomUserRes: any = await verityRoomUser({ cname: roomId })
      // const { roomInfo } = roomUserRes
      // const { breadInClassInfo } = roomInfo
      // // TODO 课前提醒老师学员是否关闭课间休息
      setBreadInClassInfo({
        restSwitch: parseInt(searchParams.get('restSwitch') || '0', 10),
        customStartTime: parseInt(searchParams.get('customStartTime') || '0', 10),
        customDuration: parseInt(searchParams.get('customDuration') || '0', 10),
        picUrl: searchParams.get('picUrl') || '',
        courseIndex: parseInt(searchParams.get('courseIndex') || '0', 10),
        startTime: parseInt(searchParams.get('startTime') || '0', 10),
        endTime: parseInt(searchParams.get('endTime') || '0', 10)
      })
      if (newCourseId) {
        // 获取课件
        const couse: any = await fetchCouseLevel3({ courseId: newCourseId })
        const { list } = couse
        let serverImages: CoursewareList[] = []
        let serverVides: VideoCoursewareList[] = []
        list.forEach(({ images = [], videos = [] }) => {
          serverImages = [...serverImages, ...images]
          serverVides = [
            ...serverVides,
            ...videos.map((video: any) => ({
              videoTitle: video.title,
              videoURL: video.url
            }))
          ]
        })
        serverImages = serverImages.map((img, i) => {
          const picUrl = img.url || ''
          const text = img.pic_word || ''
          // 如果有数据则展示提词器按钮 TODO
          // if (text) {
          //   this.changeCaptionsState('active')
          // }

          const courseType = img.type
          const courseId = i
          const picWidth = img.width
          const picHeight = img.height
          let picId
          const tmpUrl = picUrl.split('/')

          switch (courseType) {
            case 3:
              //  问答课件总页数添加埋点
              // this.addPoint("number_QAcoursepageTotal");
              picId = md5(img.zip as string)
              break
            case 2:
              //  视频课件总页数添加埋点
              // this.addPoint("number_videoCoursepageTotal");
              picId = md5(img.url as string)
              break
            default:
              picId = tmpUrl[tmpUrl.length - 1].replace(/\.\w+$/, '')
          }

          // // 课件总页数
          // this.addPoint("number_CoursewareTotal");
          return {
            ...img,
            lines: [],
            picUrl,
            picId,
            text,
            courseId,
            courseType,
            picWidth,
            picHeight,
            type: 3,
            zipUrl: img.zip,
            jsonConfig: JSON.stringify(img.json),
            metadataId: img.metadataId + ''
          }
        })
        console.log('ServerImages', serverImages, serverVides)
        if (serverImages.length) {
          setCoursewareList(serverImages)
        }
        if (serverVides.length) {
          setVideoCoursewareList(serverVides)
        }
      }

      // next - 3
      setStep(3)
    } catch (e) {
      console.info(e)
      setErrorText(JSON.stringify(e))
      setStatus('error')
    }
  }

  // 上报进出房间
  const reportInfo = async (type: 'enter' | 'quit') => {
    const { roomId, studentId } = getParams()

    let os = checkOS()
    if (os === 'MAC') {
      os += ` ${getMacOsVersion()}`
    }
    const b = getBrowser().Sys
    let browser = `${b.name} ${b.ver}`
    if (navigator.userAgent.includes('MsbClient')) {
      browser = 'MSB' + browser
    }

    await uploadTurnverInfo({
      userid: studentId,
      usertype: 'student',
      roomid: roomId,
      model: 0,
      os,
      type,
      ctime: +new Date(),
      isp: 'null',
      browser,
      classroomline: 'sw',
      useragent: navigator.userAgent
    })
      .then((res) => {
        console.info('上报:', res)
      })
      .catch((e) => console.info('上报Error:', e))
  }

  // 音视频
  const initMedia = async () => {
    try {
      const { roomId, teacherId, mainTeacherId, mainStudentId, viceTeacherId, studentId, lessonId, lessonType, lessonTimeId } = params
      const { mainCamera, viceCamera, microphone } = useDevice
      // 设置、初始化默认设备信息

      // const mainCorrect = correctInfoList.find((v) => v.userId === mainTeacherId)?.status
      // const viceCorrect = correctInfoList.find((v) => v.userId === viceTeacherId)?.status
      // 获取房间线路
      const roomLine = getRoomLine()
      let rtcToken = ''
      if (roomLine === 'zego') {
        const zegoRes = await getZegoToken({
          userId: String(mainStudentId),
          roomId: String(roomId),
          lessonTimeId: lessonTimeId ? String(lessonTimeId) : '0'
        })
        const { data } = zegoRes
        rtcToken = data.token
      }
      // RTC RTM 初始化
      const print = [
        { key: '线路:', value: roomLine },
        {
          key: 'APPID:',
          value: roomLine === 'agora' ? import.meta.env.VITE_APP_AGORA_APPID : import.meta.env.VITE_APP_ZEGO_APPID
        },
        { key: 'server:', value: import.meta.env.VITE_APP_ZEGO_URL },
        { key: 'roomId:', value: roomId },
        { key: 'teacherId:', value: teacherId },
        { key: 'studentId:', value: studentId },
        { key: 'rtmToken:', value: '' },
        { key: 'rtcToken:', value: rtcToken },
        { key: 'viceRtcToken:', value: '' }
      ]
      console.table(print)
      console.info(print)
      console.info('RTM init')
      console.info('RTC init')
      // rtm
      await rtmClient.init({ channel: roomId, uid: Number(mainStudentId) })
      await rtmClient.join()
      // rtc init and join
      await rtcClient.init({
        channel: roomId,
        uid: studentId,
        token: rtcToken
      })

      // rtm ready
      setRtmReady(true)

      // 数据交换流程
      rtmSayHello()

      const { datetime, isTempClass } = params
      const { picUrl, courseIndex = 1, startTime, endTime } = breadInClassInfo
      const now = parseInt(`${new Date().getTime() / 1000}`)
      const useTime = now - datetime

      // 临时课堂 || 课间休息没有开始时间(课间休息未开始) || 课间休息有结束时间(课间休息已过) || 上课时间超过35分钟(课间休息已过)
      // 上述情况都正常进入教室,启用音视频
      if (localStorage.STOP_ALL_RTC) {
        toast('调试模式: 音视频未启用')
      }
      if ((isTempClass || !startTime || endTime || useTime >= 2100) && !localStorage.STOP_ALL_RTC) {
        // 初始化麦克风、canvas的摄像头（只创建不publish）
        await rtcClient.changeMainCamera({
          deviceId: mainCamera,
          microphoneId: microphone,
          publish: false,
          canvas: false
        })
        if (viceCamera) {
          await rtcClient.changeViceCamera({ deviceId: viceCamera, publish: false, canvas: false })
        }
        // 统一publish
        await rtcClient.publish()
      }

      // 开始录制
      // startRecord(
      //   { key: roomId },
      //   {
      //     channel: roomId,
      //     lessonId: lessonId,
      //     platform: 'web',
      //     course_form: 1,
      //     course_type: lessonType
      //   }
      // )
      //   .then((res) => {
      //     console.info('开始录制:', res)
      //   })
      //   .catch((e) => console.info('开始录制失败:', e))

      // 录制分辨率 - 录制开始后
      // setresolution({
      //   uid: studentId,
      //   width: 640,
      //   height: 480
      // })

      // 上报进房间
      reportInfo('enter')

      // next - 4
      setStep(4)
    } catch (e) {
      console.info(e)
      setErrorText(JSON.stringify(e))
      setStatus('error')
    }
  }

  // 课件交换信令流程(注意闭包问题,state取值)
  const rtmSayHello = () => {
    // sessionStorage.type = '1'

    // 进房间信令交换流程 发送 ArtSayHello
    // 收 ArtRepHello 再发 ArtSyncAllstate
    // 收 ArtRepAllImage 再发 ArtRepAllImage

    // 在房间信令交换流程  收到 ArtSayHello
    // 发 ArtRepHello 再收到 ArtSyncAllstate
    // 发 ArtRepAllImage

    // 老师进入房间（发起「进房间信令交换流程」），同时调用channel/user接口。判断是否有学员上线（这个时候是主动判断，不在线RTM流程终止，但是会主动请求服务端课件）
    // 1.在线：等待「进房间信令交换流程」执行
    // 在收 ArtRepAllImage 如果学生课件为空的话同步下载课件同步到学生，设置syncCourse=true
    // syncCourse=true调用api/courseInfoV2接口获取服务端课件，再发送ArtPicSelecte信令同步给学员
    // 2.不在线：直接调用api/courseInfoV2接口获取服务端课件，等待学员上线进行「在房间信令交换流程」

    // 学员进入房间（发起「进房间信令交换流程」），老师是否在线，两种情况（这个时候是被动判断，不在线RTM流程终止）
    // 1.在线：等待「进房间信令交换流程」执行
    // 2.不在线：「进房间信令交换流程」将在发送 ArtSayHello后停止（对方未上线），等待老师上线进行「在房间信令交换流程」

    const { roomId, teacherId, mainTeacherId, mainStudentId, viceTeacherId, viceStudentId, lessonId, lessonType, timesRange, datetime } = params
    const { viceCamera } = useDevice
    const brower = browserType()

    const hello = {
      screenInfo: {
        width: 480,
        height: 640,
        // width: 640,
        // height: 480,
        isPortrait: false // 是否为竖屏
      },
      userInfo: {
        sl: '1,2,3',
        addrIP: '0.0.0.0',
        userType: 2,
        userId: mainStudentId,
        deviceName: `${brower.system} ${brower.systemVs} ${brower.supporter} ${brower.supporterVs}`,
        // 没有拔掉或者拔掉主镜头需要发送 exVideoId TODO
        exVideoId: Number(viceCamera || screenSharing ? viceStudentId : ''),
        platform: 3,
        userName: 'PC 学员'
      },
      isReconneted: false
    }
    // 需要取最新,所有state的值使用getState
    const getRepAllImage = () => {
      return {
        infos: getCoursewareList(),
        videos: getVideoCoursewareList(),
        createTime: datetime,
        touserid: mainTeacherId,
        currentImageid: getViewPicId()
      }
    }
    console.log('hello', hello)
    // 打招呼
    rtmClient.sendMessage('ArtSayHello', hello)
    // 同步服务端课件
    // rtmClient.sendMessage('ArtPicSelecte', {
    //   images: getCoursewareList(),
    //   videos: getVideoCoursewareList()
    // })

    // 回应
    rtmClient.on('ArtRepHello', (memberId: string, payload: any) => {
      const { repToUser, userInfo } = payload
      if (Number(memberId.slice(0, 2)) === 10) {
        setRtmUser(userInfo)
      }
      // 不是发给我的直接ret
      if (repToUser && repToUser !== mainStudentId) return
      setParams((v) => ({
        ...v,
        teacherId: Number(memberId.slice(2)),
        mainTeacherId: memberId,
        viceTeacherId: `11${memberId.slice(2)}`,
        justTeacherId: `12${memberId.slice(2)}`
      }))
      // 认定学员进教室了
      setIsTeaOnline(true)
      // 默认互看模式 设置学员第一个视频大屏
      setBigWin(3)
      // 请求数据同步
      rtmClient.sendMessage('ArtSyncAllstate', {
        toUser: memberId,
        rejoin: false
      })
      // 这里同步上课时间，确认一下临时课是否发 TODO
      if (timesRange) {
        rtmClient.sendMessage('ArtClassStart', {
          startTime: datetime,
          status: 1
        })
      }
      // 发送矫正信息
      rtmClient.sendMessage('ArtVideoPerspective', {
        windowStatus: 1,
        type: 3,
        toUser: mainTeacherId,
        ...defaultPos
      })
      rtmClient.sendMessage('ArtVideoPerspective', {
        windowStatus: 1,
        type: 3,
        toUser: viceTeacherId,
        ...defaultPos
      })
      rtmClient.sendMessage('ArtCommandControl', {
        cmdType: 7,
        cmdBehavior: 4,
        toUser: params.mainTeacherId
      })
    })
    // 课件
    rtmClient.on('ArtRepAllImage', (memberId: string, payload: any) => {
      console.log(memberId, payload)
      // 存一下页码
      const { currentImageid, infos, videos } = payload
      setViewPicId(currentImageid)
      setCoursewareList(infos.map((v: any) => ({ ...v, json: JSON.parse(v.jsonConfig || '{}') })))
      setVideoCoursewareList(videos)
      // 如果课件中有上传或者临时的怎么处理，这里备注一下是否取这里的课件还是服务端的课件
    })
    // 画线
    rtmClient.on('ArtRepLine', (memberId: string, payload: any) => {
      const { touserid } = payload
      // 不是发给我的直接ret
      if (touserid && touserid !== mainStudentId) return
      console.log(memberId, payload)

      // ---- 画线回显 ----
      const { lines } = payload
      const pageData: PageData = {}
      let isLine = false
      lines.forEach((v: { windowId: string; Lines: Lines[] }) => {
        let board: Board | null = null
        const preId = v.windowId.slice(0, 2)
        // 课件ID都是32/36/40位的,default_disImage=16位,其他为视频白板
        if (v.windowId.length > 20) {
          if (v.Lines && v.Lines.length) {
            isLine = true
            pageData[v.windowId] = v.Lines
          }
        } else if (v.windowId === 'default_disImage') {
          board = coursewareBoard
        } else {
          board = boardToPrefix[preId]
        }
        // 视频画线
        if (board) {
          v.Lines && v.Lines.length && board.setPagesData({ [v.windowId]: v.Lines }), board.pageDraw()
        } else {
          console.warn('其他画线,画线ID: ', v.windowId, v)
        }
      })
      // 课件画线
      if (isLine) {
        coursewareBoard.setPagesData(pageData)
        coursewareBoard.pageDraw()
      }
      // ---- 画线回显 ----

      rtmClient.sendMessage('ArtRepAllImage', {
        ...getRepAllImage(),
        createTime: datetime,
        currentImageid: getViewPicId(),
        touserid: memberId
      })
    })
    // 打招呼
    rtmClient.on('ArtSayHello', (memberId: string, payload: any) => {
      const { userInfo } = payload
      if (Number(memberId.slice(0, 2)) === 10) {
        setRtmUser(userInfo)
      }
      setParams((v) => ({
        ...v,
        teacherId: Number(memberId.slice(2)),
        mainTeacherId: memberId,
        viceTeacherId: `11${memberId.slice(2)}`,
        justTeacherId: `12${memberId.slice(2)}`
      }))

      // 师生互看
      if (getSyncState() !== 'active' && getSyncState() !== 'classPage') {
        setBigWin(3)
      }
      // TODO 发送给远端摄像头状态
      // rtmClient.sendMessage("ArtCommandControl", {
      //   cmdType: 9,
      //   cmdBehavior: 1,
      //   toUser: item
      // });
      rtmClient.sendMessage('ArtRepHello', {
        ...hello,
        repToUser: memberId
      })
      // TODO 进入房间发送透视矫正数据，如果没有发送重置数据 老师的？
      rtmClient.sendMessage('ArtVideoPerspective', {})
      // 副摄像头 TODO
      rtmClient.sendMessage('ArtVideoPerspective', {})
      // 主摄像头拔掉 TODO
      // rtmClient.sendMessage('ArtVideoConnect', {
      //   videoId: Number(mainTeacherId)
      // })
      // 主副摄像头拔掉 TODO
      // rtmClient.sendMessage('ArtVideoConnect', {
      //   videoId: Number(mainTeacherId),
      //   exVideoId: viceTeacherId
      // })
      rtmClient.sendMessage('ArtCommandControl', {
        cmdType: 7,
        cmdBehavior: 4,
        toUser: params.mainTeacherId
      })
    })
    // 请求数据同步
    rtmClient.on('ArtSyncAllstate', (memberId: string, payload: any) => {
      console.log('ArtSyncAllstate')
      const { toUser } = payload
      // 不是发给我的直接ret
      if (toUser && toUser !== mainStudentId) return
      // 同步课件
      rtmClient.sendMessage('ArtRepAllImage', {
        ...getRepAllImage(),
        createTime: datetime,
        currentImageid: getViewPicId(),
        touserid: memberId
      })
      // 画笔样式
      rtmClient.sendMessage('ArtPenStyle', {
        color: getLineColor().replace('#', ''),
        lineWidth: getLineWidth()
      })
      // just 状态
      const justUserInfo: { userId: string; isSelected: boolean }[] = []
      const newJustUser = getJustUser()
      Object.keys(newJustUser).forEach((v) => {
        justUserInfo.push({
          userId: v, // 10xxx,20xxx
          isSelected: newJustUser[v]
        })
      })
      rtmClient.sendMessage('ArtExtensionVideo', { userInfo: justUserInfo })
      // 画笔权限
      rtmClient.sendMessage('ArtWindowStateInfo', {
        brushUserId: getPenState() ? getParams().mainStudentId : getParams().mainTeacherId,
        syncUserId: getSyncState() === 'active' ? getParams().mainTeacherId : ''
      })
      // 检测对方性能
      rtmClient.sendMessage('ArtCheckPerformance', { open: false })
      // 判断是否同屏，如果同屏发送同屏消息及窗口信息
      // if (getSyncState() === 'active') {
      // rtmClient.sendMessage('ArtSyncScreen', {
      //   frameDic: fromBase64(encode(JSON.stringify({ [getBigWin()]: bigWindow, 0: bigWindow }))),
      //   state: 1,
      //   imageInfo: {
      //     picId: getViewPicId()
      //   }
      // })
      // } else if (getSyncState() === 'classPage') {
      toast('切换至师生互看模式')
      setSyncState('normal')
      // rtmClient.sendMessage('ArtCommandControl', { cmdType: 12 })
      // }

      // 画线数据
      const lines = [
        ...mainStudentVideoBoard.getPagesData(),
        ...viceStudentVideoBoard.getPagesData(),
        ...justStudentVideoBoard.getPagesData(),
        ...mainTeacherVideoBoard.getPagesData(),
        ...viceTeacherVideoBoard.getPagesData(),
        ...justTeacherVideoBoard.getPagesData(),
        ...coursewareBoard.getPagesData()
      ]
      getRepAllImage().infos.forEach((v) => {
        const line = lines.find((line) => line.windowId === v.picId)
        if (!line) {
          lines.push({ windowId: v.picId, Lines: [] })
        }
      })
      rtmClient.sendMessage('ArtRepLine', { lines, touserid: memberId })
    })
    // 图片消息
    rtmClient.on('ArtPicImage', (memberId: string, payload: any) => {
      const { imageInfo } = payload
      // picId去重
      setCoursewareList((v) => unionBy([...v, ...imageInfo], 'picId'))
      setViewPicId(imageInfo[0].picId)
    })
    // 学员是否在后台运行
    // rtmClient.on('ArtEnterBackgroundControl', (memberId: string, payload: any) => {
    //   const { back } = payload
    //   // picId去重
    //   setEnterBackgroundControl(back)
    // })

    // 下面未使用

    // 视频信息
    rtmClient.on('ArtVideoInfo', (memberId: string, payload: any) => {
      // 老视频课件 TODO
    })
    // 视频操作
    rtmClient.on('ArtConVideo', (memberId: string, payload: any) => {})
    // 视频同步
    rtmClient.on('ArtSyncVideo', (memberId: string, payload: any) => {
      // 视频同步 TODO
    })
    // 时间
    rtmClient.on('ArtClassStart', (memberId: string, payload: any) => {})
    // 同步视频及部分指令
    rtmClient.on('ArtWindowStateInfo', (memberId: string, payload: any) => {
      // 关于画笔：
      // 学员未上线，不能授权，即使授权走的ArtCommandControl协议，cmdType=2时
      // 老师退出，学员自己放弃画笔权限和上传图片权限
      // 学员退出，老师收回画笔权限
    })
    // 画笔清屏
    rtmClient.on('ArtClearLine', (memberId: string, payload: any) => {
      const { mainStudentId, viceStudentId, justStudentId, mainTeacherId, viceTeacherId, justTeacherId } = getParams()
      const { windowId } = payload
      let board = coursewareBoard
      const boards: { [key: string]: Board } = {
        [mainStudentId]: mainStudentVideoBoard,
        [viceStudentId]: viceStudentVideoBoard,
        [justStudentId]: justStudentVideoBoard,
        [mainTeacherId]: mainTeacherVideoBoard,
        [viceTeacherId]: viceTeacherVideoBoard,
        [justTeacherId]: justTeacherVideoBoard
      }
      if (windowId in boards) {
        board = boards[windowId]
      }
      board.clear(1, windowId, false)
    })
    // 画线
    rtmClient.on('ArtDrawLine', (memberId: string, payload: any) => {})
    // 画笔样式
    rtmClient.on('ArtPenStyle', (memberId: string, payload: any) => {
      const { color, lineWidth } = payload
      mainStudentVideoBoard.setConf({ lineWidth })
      viceStudentVideoBoard.setConf({ lineWidth })
      justStudentVideoBoard.setConf({ lineWidth })
      mainTeacherVideoBoard.setConf({ lineWidth })
      viceTeacherVideoBoard.setConf({ lineWidth })
      justTeacherVideoBoard.setConf({ lineWidth })
      coursewareBoard.setConf({ lineWidth })

      mainStudentVideoBoard.setConf({ brushColor: `#${color}` })
      viceStudentVideoBoard.setConf({ brushColor: `#${color}` })
      justStudentVideoBoard.setConf({ brushColor: `#${color}` })
      mainTeacherVideoBoard.setConf({ brushColor: `#${color}` })
      viceTeacherVideoBoard.setConf({ brushColor: `#${color}` })
      justTeacherVideoBoard.setConf({ brushColor: `#${color}` })
      coursewareBoard.setConf({ brushColor: `#${color}` })
    })
    /**
     * @export ArtCommandControl 控制命令
     * @param {*} cmdType & cmdBehavior
     * 1 取消霸屏
     * 2 废弃
     * 3 授权画笔
     * 4 ios精简模式 cmdBehavior: 1 是 0 否
     * 5 未使用
     * 6 视频流超过数量踢人 cmdBehavior: 0 管理员 1 请出房间 2 正在上课
     * 7 切换窗口调用分辨率 cmdBehavior: 0 240p 1 360p 2 480p 3 720p
     * 8 横竖屏 Behavior: 0 竖屏 1 横屏
     * 9 关闭视频流 Behavior: 0 开启 1 关闭
     * 10 未使用
     * 11 未使用
     */
    rtmClient.on('ArtCommandControl', (memberId: string, payload: any) => {
      const { mainStudentId, mainTeacherId } = getParams()
      console.log('payload', payload, mainStudentId, mainTeacherId)
      const { toUser, cmdType, cmdBehavior } = payload
      // roomEvent.emit('lottie', type) TODO
      // 互看命令
      if (cmdType === 1) {
        setSyncState('normal')
        toast('切换至师生互看模式')
      }
      // 画笔权限
      if (cmdType === 2) {
        if (mainStudentId === toUser) {
          setPenState(false)
        }
        if (mainTeacherId === toUser) {
          setPenState(true)
        }
      }
      // 关闭老师、学生摄像头
      if (cmdType === 9) {
        // TODO 好像这个功能没了
      }
      // 奖励
      if (cmdType === 11) {
        const rewardSignaCode: { [key: string]: 'praise' | 'flower' | 'sun' | 'willEnd' | 'alarmClock' | 'courseRight' } = {
          1: 'flower',
          2: 'sun',
          3: 'praise',
          4: 'willEnd',
          5: 'alarmClock',
          6: 'courseRight' // 6为互动课件奖励
        }
        roomEvent.emit('lottie', rewardSignaCode[cmdBehavior])
      }
      // 课件模式
      if (cmdType === 12) {
        setSyncState('classPage')
        toast('切换至课件模式')
      }
    })
    // 霸屏？
    rtmClient.on('ArtSyncScreen', (memberId: string, payload: any) => {
      // 那个是大屏
    })
    // 切换线路
    rtmClient.on('ArtConVideoLine', (memberId: string, payload: any) => {
      // 切换线路
      window.history.back()
    })
    // 通知
    rtmClient.on('ArtNotifyMessage', (memberId: string, payload: any) => {
      // 老视频课件播放时，学员根据播放进度提示老师降低视频质量 TODO
    })
    // 透视矫正
    rtmClient.on('ArtVideoPerspective', (memberId: string, payload: any) => {})
    // 翻页
    rtmClient.on('ArtPicChange', (memberId: string, payload: any) => {
      const { imageInfo } = payload
      if (imageInfo.picId) {
        setViewPicId(imageInfo.picId)
      }
    })
    // 同步课件
    rtmClient.on('ArtPicSelecte', (memberId: string, payload: any) => {})
    // 对方关闭
    rtmClient.on('ArtSayBye', (memberId: string, payload: any) => {})
  }

  // 课堂计时器
  const roomTimeClock = async (datetime: number) => {
    const res: any = await getServerTimes()
    // 四舍五入，误差小于500ms
    const serveTime = Math.round(res / 1000)
    roomDateTimeRef.current = serveTime - datetime
    if (roomTimeRef.current >= 0) {
      clearInterval(roomTimeRef.current)
      roomTimeRef.current = -1
    }
    if (roomDateTimeRef.current > classTimeout) {
      return true
    }
    roomTimeRef.current = setInterval(() => {
      roomDateTimeRef.current += 1
      // 1分钟修正一次
      if (roomDateTimeRef.current % 60 === 0) {
        getServerTimes().then((res: any) => {
          // 四舍五入，误差小于500ms
          const serveTime = Math.round(res / 1000)
          roomDateTimeRef.current = serveTime - datetime
        })
      }
      // args0=已上课秒 args1=10位服务器时间
      roomEvent.emit('roomTime', roomDateTimeRef.current, datetime + roomDateTimeRef.current)
      // 60分钟整点下课动画提醒
      // if (roomDateTimeRef.current === 3600) {
      //   roomEvent.emit('lottie', 'alarmClock')
      // }
      if (roomDateTimeRef.current > classTimeout) {
        toast.error('本节课程已超时,正在退出教室')
        // navigate('/center')
        window.history.back()
      }
    }, 1000)
  }

  // 退出
  const exit = () => {
    // navigate('/center')
    window.history.back()
  }

  // 是否隐藏在页面中
  const hiddenInView = roomWindowScale !== 'full'
  return (
    <Container className="w-screen h-screen bg-room bg-center bg-cover bg-no-repeat overflow-x-auto overflow-y-hidden scrollbar-style">
      {step >= 3 ? (
        <>
          {/* h=6vh */}
          {/* <Head /> */}

          {/* h=90vh my=2vh */}
          <Center className={`${hiddenInView ? 'w-full h-full' : 'w-[164.875vh] h-[96vh] my-[2vh]'} relative flex justify-between items-center  m-auto`}>
            {/* 视频 w=16.875vh 单个 h=22.5vh 间距=2vh */}
            <Video />
            {/* 老师视频a */}
            {params.teacherId ? <TeacherVideo /> : <TeacherTemp />}
            {/* 课件 w=120vh h=90vh */}
            <div hidden={hiddenInView}>
              <Courseware />
              {/* 工具栏 w=6vh */}
              {/* <Tools /> */}
              {/* 课间休息 zIndex=99 */}
              <Rest />
            </div>
          </Center>

          {/* 奖励 */}
          <Reward />
          {/* 高光时刻 */}
          <VideoFrame />
          {/* 踢出 */}
          <Modal show={outState} title="异地登录" shadowClick={false} close={false} cancelText="" confirm={exit}>
            <p className="text-[14px] text-[#666666]">该账户已在别处登录,您即将退出教室</p>
          </Modal>
          {/* 设备变化提醒 */}
          <GlobalDeviceChange />
          {/* 处理一些纯事件 */}
          <ReadyEvent />
        </>
      ) : null}
      {step !== 5 ? <Step status={status} step={step} errorTxt={errorTxt} /> : null}
      <div className="fixed z-50 bottom-0 h-[16px] w-screen text-center text-[12px] text-[rgba(255,255,255,0.3)] text-s">{import.meta.env.VITE_APP_TIME}</div>
    </Container>
  )
}

const Container = styled(motion.div)``
const Center = styled(motion.div)``
